<div class="resumen-container">

  <div class="info">

    <div class="header">
      <span class="titulo">Sucursales seleccionadas</span>

      <span class="contador">
        {{ sucursalesSeleccionadas.length }}
      </span>
    </div>

    <div class="tags">

      <span
        class="tag"
        *ngFor="let sucursal of sucursalesSeleccionadas"
      >
        <i class="pi pi-map-marker icono"></i>
        {{ sucursal }}
      </span>

    </div>

  </div>

  <button
    pButton
    type="button"
    label="Cambiar selección"
    icon="pi pi-arrow-left"
    class="btn-cambiar p-button-text"
    (click)="volverDashboard()"
  ></button>

</div>
